// extracted by mini-css-extract-plugin
export default {"body-container":"styles_body-container__QXiIp","right-block":"styles_right-block__ITVEd"};